import { Component, OnInit } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { TabsModule } from 'primeng/tabs';
import { TitresPrimaryComponent } from './titres-primary/titres-primary.component';
import { TitresSecondaryComponent } from './titres-secondary/titres-secondary.component';
import { TitresHistoryComponent } from './titres-history/titres-history.component';

@Component({
    selector: 'app-titres-management',
    imports: [
        CommonModule,
        TabsModule,
        NgComponentOutlet
    ],
    templateUrl: './titres-management.component.html',
    styleUrl: './titres-management.component.scss'
})
export class TitresManagementComponent implements OnInit {
  items: { label: string }[] = [];
  selectedTab: { title: string, component: any } | null = null;

  ngOnInit() {
    this.items = [
      { label: 'Marché Primaire' },
      { label: 'Marché Secondaire' },
      { label: 'Historique' }
    ];
    this.selectTab('Marché Primaire');
  }

  selectTab(tabTitle: string) {
    if (tabTitle === 'Marché Primaire') {
      this.selectedTab = { title: 'Marché Primaire', component: TitresPrimaryComponent };
    } else if (tabTitle === 'Marché Secondaire') {
      this.selectedTab = { title: 'Marché Secondaire', component: TitresSecondaryComponent };
    } else if (tabTitle === 'Historique') {
      this.selectedTab = { title: 'Historique', component: TitresHistoryComponent };
    }
  }
}
